<script lang="ts" setup>
import * as emailValidator from 'email-validator';

definePageMeta({
  layout: 'plain',
});

const rules = {
  email: [
    (v: string) => !!v || 'Voer je email adres in',
    (v: string) => emailValidator.validate(v) || 'Dit email adres klopt niet',
  ],
  length: (len: number) => (v: string) =>
    (v || '').length >= len ||
    `Wachtwoord moet uit minimaal 6 karakters bestaan`,
  password: [
    (v: string) => !!v || 'Voer je wachtwoord in',
    // (v: string) => v.length > 5 || "Wachtwoord moet uit minimaal 6 karakters bestaan",
    (v: string) =>
      v.match(/[0-9]/) != null ||
      'Wachtwoord moet minimaal één cijfer bevatten',
    (v: string) =>
      v.match(/[a-z]/) != null ||
      'Wachtwoord moet minimaal één kleine letter bevatten',
    (v: string) =>
      v.match(/[A-Z]/) != null ||
      'Wachtwoord moet minimaal één hoofdletter bevatten',
  ],
};
const email = ref('');
const password = ref('');
const loginForm = ref(null);
const loading = ref(false);
const message = ref(
  'Een account is nodig om templates op te slaan en de statusvoering te versleuteld op te slaan in de browser.'
);
const next = ref(false);

async function SignOn() {
  const { $sentry } = useNuxtApp();

  if (email.value.length > 1 && password.value.length > 6) {
    loading.value = true;
    await createAccount(email.value, password.value).catch((error) => {
      loading.value = false;
      $sentry.captureException(error);
    });
    // FIXME: (fix) store new user locally (multiple users per browser should be possible)

    message.value =
      'In je mailbox zit een bericht om je email adres te bevestigen. Daarna kun je inloggen.';
    next.value = true;
    loading.value = false;
  }
}

function count() {
  if (password.value.length > 6) return false;

  return 6;
}
</script>

<template>
  <!-- theme class needed for css variables -->
  <div
    class="main-layout register-screen bg-surface d-flex justify-space-around align-center"
  >
    <v-card class="login-form elevation-5">
      <v-toolbar
        cards
        flat
        color="primary"
      >
        <v-card-title class="text-h6 font-weight-regular">
          Registreren
        </v-card-title>
      </v-toolbar>
      <v-form
        v-if="!loading"
        v-model="loginForm"
        class="pa-4 pt-6"
        @keyup.prevent.enter="loginForm && SignOn()"
      >
        <div class="pb-4">
          <p class="text-body-2">
            {{ message }}
          </p>
        </div>
        <v-text-field
          v-if="!next"
          v-model="email"
          :rules="rules.email"
          variant="filled"
          color="primary"
          label="Email adres"
          type="email"
          class="pb-2"
        />
        <v-text-field
          v-if="!next"
          v-model="password"
          :rules="[...rules.password, rules.length(6)]"
          variant="filled"
          color="primary"
          :counter="count()"
          label="Wachtwoord"
          type="password"
        />
      </v-form>
      <div
        v-if="!loading && !next"
        class="pb-4 pl-4"
      >
        <p class="text-body-2">
          Al een account? <NuxtLink to="/">Log in</NuxtLink>
        </p>
      </div>
      <div
        v-if="loading"
        class="d-flex justify-space-around align-center my-6"
      >
        <Loader />
      </div>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="!next"
          :disabled="!loginForm"
          color="primary"
          @click="loginForm && SignOn()"
        >
          Maak aan
        </v-btn>
        <v-btn
          v-if="next"
          color="primary"
          to="/"
        >
          Log in
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style lang="scss" local>
.main-layout.register-screen {
  .login-form {
    width: 500px;
  }

  margin-top: 0;
  margin-bottom: 0;
  height: 100vh;
  width: 100vw;
}

// Prevent flicker when vuetify switches to dark theme
@media (prefers-color-scheme: dark) {
  .main-layout {
    background-color: rgb(30 30 30) !important;

    .v-card {
      background-color: rgb(30 30 30);
      color: rgb(255 255 255);

      .v-toolbar {
        background: rgb(82 139 255) !important;
      }

      a {
        color: rgb(158 158 255);
      }

      .v-btn {
        color: rgb(82 139 255);
      }
    }
  }
}

@media (width <= 600px) {
  .main-layout {
    height: 100vh;
  }
}
</style>
